import { useApi } from "../../hooks/use-api";
import { useNavigate } from "react-router-dom";
import { useSingleton } from "../../hooks/use-singleton";
import { useNotify } from "../../hooks/use-notify";
import { useEffect, useState } from "react";
import { ROUTE_ADMIN_QUIZ_ROOM } from "../../route/teacherRoute";

export const useHandler = () => {
  const { get, post } = useApi();
  const navigate = useNavigate();
  const { toggleNotify } = useNotify();
  const [roomDetails, setRoomDetails] = useState([]);
  const [testDetails, setTestDetails] = useState();
  const [tierDetails, setTierDetails] = useState();
  const [studentMailDetails, setStudentMailDetails] = useState();
  const [showAsyncModal, setShowAsyncModal] = useState(false);
  const [showAddStudentsModal, setShowAddStudentsModal] = useState(false);
  const [testMode, setTestMode] = useState("live");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [createdTest, setCreatedTest] = useState({});
  const [publishData, setPublishData] = useState(null);
  const [formData, setFormData] = useState({
    test_name: "",
    student_tier: "",
  });
  const [newTableData, setNewTableData] = useState();
  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [createdDetails, setCreatedDetails] = useState();
  const [studentCodeDetails, setStudentCodeDetails] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const { mail, role } = useSingleton();
  const { test_name, student_tier } = formData;

  const { room_code } = createdDetails || {};

  const today = new Date();

  const formattedDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1,
  ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  const currentTime = new Date().toISOString().split("T")[1];

  // const getRoomDetails = async (mode = "") => {
  //   try {
  //     const res = await get(apiTeacherRoom(mail));
  //     if (res) {
  //       setRoomDetails(res?.data?.rooms);
  //     }
  //   } catch (e) {
  //     console.log("Error getting room details", e);
  //   }
  // };

  const getTestNameDetails = async () => {
    try {
      const res = await get(
        `teacher/test/list?email=${mail}&role=${role}&page=1&page_size=100`,
      );
      if (res) {
        const tests =
          res?.data?.tests ||
          res?.tests ||
          (Array.isArray(res?.data) ? res.data : []);
        setTestDetails(tests);
      }
    } catch (e) {
      console.log("ERROR GET TEST NAME DETAILS API", e);
    }
  };

  const getStudentTierDetails = async () => {
    try {
      const res = await get("api/teacher/student-performance/tiers");
      if (res) {
        const { tiers } = res?.data;
        setTierDetails(tiers);
      }
    } catch (e) {
      console.log("ERROR GET STUDENT TIER DETAILS API", e);
    }
  };

  // const getAllStudentDetails = async () => {
  //   try {
  //     const res = await get("");
  //     if (res) {
  //       setStudentDetails(res?.data);
  //     }
  //   } catch (e) {
  //     console.log("ERROR GET ALL STUDENT DETAILS API", e);
  //   }
  // };

  const onChangeValue = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const onAddStudents = async () => {
  //   const res = await post("");

  //   if (res) {
  //     setCreatedTest(res?.data);

  //     setShowAddStudentsModal(false);

  //     setShowSuccessModal(true);
  //   }
  // };

  const getApiNewTableDatas = async () => {
    try {
      const res = await get(
        `api/teacher/test-management/tests?teacher_email=${mail}&test_type=${activeTab}&page=1&page_size=100`,
      );

      if (res) {
        console.log(res?.data);
        setNewTableData(res.data.tests);
      }
    } catch (e) {
      console.log("ERROR COMES FROM GET NEW TABLE DATAS API ", e);
    }
  };

  const resolveTier = (tier) => {
    if (!tier || tier === "All" || tier === "all") return "All";
    const lower = String(tier).toLowerCase();
    if (lower.includes("top")) return "top_tier";
    if (lower.includes("mid")) return "mid_tier";
    if (lower.includes("low")) return "low_tier";
    return "All";
  };

  const isChapterName = (val) => {
    if (!val || typeof val !== "string") return false;
    const lower = val.trim().toLowerCase();
    return (
      lower.startsWith("chapter:") ||
      lower.startsWith("chapter :") ||
      lower.startsWith("chapter-") ||
      lower.startsWith("chapter ")
    );
  };

  const getStudentMailsList = async (customTestName, customRoomCode) => {
    if (!mail) return;
    const selectTier = resolveTier(student_tier);
    let targetTestName = customTestName || test_name || "";
    const targetRoomCode =
      customRoomCode ||
      room_code ||
      createdDetails?.room_code ||
      createdDetails?.roomCode ||
      createdDetails?.data?.room_code ||
      "";

    if (isChapterName(targetTestName)) {
      targetTestName = "";
      if (targetRoomCode && Array.isArray(newTableData)) {
        const found = newTableData.find(
          (t) => String(t?.room_code || t?.roomCode) === String(targetRoomCode)
        );
        if (found && (found.test_name || found.testName) && !isChapterName(found.test_name || found.testName)) {
          targetTestName = found.test_name || found.testName;
        }
      }
    }

    try {
      let url = `api/teacher/test-management/students?teacher_email=${mail}&tier=${selectTier}`;
      if (targetTestName) {
        url += `&test_name=${encodeURIComponent(targetTestName)}`;
      }
      url += `&page=1&page_size=5000`;
      if (targetRoomCode) {
        url += `&room_code=${encodeURIComponent(targetRoomCode)}`;
      }
      const res = await get(url);
      if (res) {
        setStudentMailDetails(res?.data?.students || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM GET STUDENT MAIL LIST", e);
    }
  };

  const [isApplying, setIsApplying] = useState(false);

  const applyTestDetails = async () => {
    setIsApplying(true);
    const selectTier = resolveTier(student_tier);

    const selectedTestObj = Array.isArray(testDetails)
      ? testDetails.find(
          (t) => (t?.test_name || t?.testName) === test_name
        )
      : null;

    const durationMinutes =
      selectedTestObj?.duration_minutes ??
      selectedTestObj?.duration ??
      45;

    const scheduledTime =
      selectedTestObj?.test_time ||
      selectedTestObj?.testTime ||
      currentTime;

    const scheduledDateVal =
      selectedTestObj?.test_date ||
      selectedTestObj?.testDate ||
      formattedDate;

    const payload = {
      teacher_email: mail,
      test_name,
      mode: testMode,
      student_tier: selectTier,
      scheduled_date: scheduledDateVal,
      scheduled_time: scheduledTime,
      duration_minutes: Number(durationMinutes) || 45,
    };
    try {
      const res = await post("api/teacher/test-management/tests", payload);
      setIsApplying(false);
      if (res && (res.status === 200 || res.status === 201 || res.data)) {
        const resData = res.data || {};
        setCreatedDetails(resData);
        const createdRoomCode =
          resData.room_code ||
          resData.roomCode ||
          resData?.data?.room_code ||
          resData?.data?.roomCode ||
          "";
        await getStudentMailsList(test_name, createdRoomCode);
        return true;
      }
      return false;
    } catch (e) {
      setIsApplying(false);
      console.log("ERROR CREATING TEST: ", e);
      return false;
    }
  };

  const apiTestRoomCodeStudents = async (emails) => {
    setIsLoading(true);
    const payload = {
      emails,
    };
    try {
      const res = await post(
        `api/teacher/test-management/${room_code}/students`,
        payload,
      );

      if (res) {
        const studentResData = res?.data?.data || res?.data || res || {};
        setStudentCodeDetails((prev) => ({
          ...createdDetails,
          ...prev,
          ...studentResData,
        }));
        setShowAddStudentsModal(false);
        setShowSuccessModal(true);
        setIsLoading(false);
        await getApiNewTableDatas();
      }
    } catch (e) {
      setIsLoading(false);
      console.log("ERROR COMES FROM API TEST S");
    }
  };

  const apiTestOnPublish = async () => {
    setIsLoading(true);
    try {
      const res = await post(
        `api/teacher/test-management/${room_code}/publish`,
        {},
      );
      if (res) {
        const data = res?.data || res || {};
        setPublishData(data);

        const count = data.students_notified !== undefined ? Number(data.students_notified) : 1;
        const msg = count === 1 ? "1 student is notified" : `${count} students are notified`;

        if (toggleNotify) {
          toggleNotify({
            type: "success",
            title: "Test Published",
            description: msg,
          });
        }

        await getApiNewTableDatas();
        navigate(ROUTE_ADMIN_QUIZ_ROOM, {
          state: {
            mode: data.mode,
            roomCode: data.room_code,
            testName: data.test_name || test_name,
            test_name: data.test_name || test_name,
          },
        });
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      if (toggleNotify) {
        toggleNotify({
          type: "error",
          title: "Publish Failed",
          description: "Failed to publish test.",
        });
      }
      console.log("ERROR COMES FROM TEST ON PUBLISH API", e);
    }
  };

  useEffect(() => {
    getTestNameDetails();
  }, []);

  useEffect(() => {
    getStudentTierDetails();
  }, []);

  useEffect(() => {
    getApiNewTableDatas();
  }, [activeTab]);

  return {
    roomDetails,
    testDetails,
    tierDetails,
    studentMailDetails,
    showAsyncModal,
    formData,
    showAddStudentsModal,
    testMode,
    showSuccessModal,
    createdTest,
    newTableData,
    activeTab,
    searchQuery,
    selectedStudents,
    createdDetails,
    studentCodeDetails,
    currentPage,
    isLoading,
    isApplying,
    getApiNewTableDatas,
    setSearchQuery,
    setSelectedStudents,
    onChangeValue,
    setStudentMailDetails,
    setTestDetails,
    setTierDetails,
    setShowAsyncModal,
    setShowAddStudentsModal,
    setTestMode,
    setShowSuccessModal,
    setCreatedTest,
    setActiveTab,
    applyTestDetails,
    getStudentMailsList,
    apiTestRoomCodeStudents,
    apiTestOnPublish,
    navigate,
    setCurrentPage,
  };
};
